import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStateProvider from "./lib/GlobalContext";
import "./i18n";
import { ConfigProvider } from "antd";
import deDE from "antd/lib/locale/de_DE";

const root = ReactDOM.createRoot(document.getElementById("reactRoot") as HTMLElement);

root.render(
  <div id="reactContainer">
    {/* <React.StrictMode> */}
      <div id="appRoot" aria-label="App Root" />
      <GlobalStateProvider>
        <ConfigProvider locale={deDE}>
          <App />
        </ConfigProvider>
      </GlobalStateProvider>
    {/* </React.StrictMode> */}
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
